export class AddOrRemoveTaskEventDataModel {
  /**ID проекта */
  ProjectId!: number;
  /**Название проекта */
	ProjectName!: string;
  /**Изображение проекта */
	ProjectImageUrl!: string;
  /**Цвет проекта */
  ProjectPreviewColor!: string;
  
  constructor(obj?: Partial<AddOrRemoveTaskEventDataModel>) {
    Object.assign(this, obj);
  }
}